import { NotificationsState, NotificationT } from 'lib-shared-legacy-types';
import { createSelector } from 'reselect';

import type { RootReducerStateT } from 'app/reducers/rootReducer';

/**
 * Helper function to get notification type as the second argument when using
 * selectors.
 */
const selectType = (_: RootReducerStateT, type: string): string => type;

export const getNotificationsState = (
  state: RootReducerStateT,
): NotificationsState => state.notifications;

/** Selects current notifications. */
export const selectCurrentNotifications = (
  state: RootReducerStateT,
): NotificationT[] => getNotificationsState(state).currentNotifications;

/** Selects current notifications having given type. */
export const selectCurrentNotificationsByType = createSelector(
  [selectCurrentNotifications, selectType],
  (notifications: NotificationT[], type) =>
    notifications.filter((notification) => notification.type === type),
);
